<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h630_dialog abow_dialog"
      width="1300px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogAddEditViewForm"
        :model="dialogAddEditViewForm"
        :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item
                  label="名称"
                  prop="name"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.name"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="工资条数"
                  prop="infoCount"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.infoCount"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="应发总金额"
                  prop="payableTotal"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.payableTotal"
                    disabled
                  >
                    <template slot="append">
                      元
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="实发总金额"
                  prop="paymentTotal"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.paymentTotal"
                    disabled
                  >
                    <template slot="append">
                      元
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="modal-box">
          <h3 class="modal-title">
            外聘人员工资明细汇总
          </h3>
          <div class="modal-row-box">
            <el-row
              :gutter="10"
              style="margin-bottom:10px;"
            >
              <el-col :span="24">
                <el-table
                  :data="infoListData"
                  class="public-table"
                  :header-cell-style="{background:'#0076ff'}"
                  style="width: 100%"
                  border
                >
                  <el-table-column type="expand">
                    <template slot-scope="props">
                      <el-table
                        :data="props.row.infoList"
                        class="public-table"
                        :header-cell-style="{background:'#00c5cc'}"
                        style="width: 100%"
                        border
                      >
                        <el-table-column
                          type="index"
                          label="序号"
                          width="60"
                          align="center"
                        />
                        <el-table-column
                          prop="employeeName"
                          label="人员名称"
                          width="140"
                          align="center"
                        />
                        <el-table-column
                          prop="schemeNo"
                          label="方案编号"
                          width="200"
                          align="center"
                        />
                        <el-table-column
                          prop="schemeName"
                          label="方案名称"
                          align="center"
                        />
                        <el-table-column
                          prop="activityDate"
                          label="活动日期"
                          width="100"
                          align="center"
                        />
                        <el-table-column
                          prop="payableAmount"
                          label="应发金额"
                          width="100"
                          align="center"
                        />
                        <el-table-column
                          label="实发金额"
                          width="140"
                          align="center"
                          prop="paymentAmount"
                        />
                      </el-table>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="provinceName"
                    label="省区名称"
                    width="120"
                    align="center"
                  />
                  <el-table-column
                    prop="cityName"
                    label="城市名称"
                    width="120"
                    align="center"
                  />
                  <el-table-column
                    prop="employeeName"
                    label="人员名称"
                    width="140"
                    align="center"
                  />
                  <el-table-column
                    prop="payableTotal"
                    label="应发合计"
                    align="center"
                  />
                  <el-table-column
                    prop="paymentTotal"
                    label="实发合计"
                    align="center"
                  />
                </el-table>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="modal-box">
          <h3 class="modal-title">
            备注信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item prop="remark">
                  <el-input
                    v-model="dialogAddEditViewForm.remark"
                    type="textarea"
                    placeholder="备注"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="isExport"
          type="primary"
          @click="exportSummaryInfoById"
        >
          导出人员汇总
        </el-button>
        <el-button
          v-if="isExport"
          type="primary"
          @click="exportInfoById"
        >
          导出人员明细
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// 权限验证
import checkPermission from '@/utils/permission'
// API
import { viewSalaryExternalEmployeeSalaryBillApi, findSummaryInfoByIdApi, exportSummaryInfoByIdApi, exportInfoByIdApi } from '@/api/v2/salaryExternalEmployeeSalaryBill'

export default {
  components: {},
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {},
      infoListData: [],
      isExport: false
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;

        _this.infoListData = []
        _this.isExport = false

        _this.dialogAddEditViewForm = {
          name: '',
          infoCount: 0,
          performanceTotal: 0,
          realPerformanceTotal: 0,
          deductTotal: 0,
          remark: ''
        }
        // 是否有变更权限
        if (checkPermission(['salary_activity_performance_bill_export'])) {
          _this.isExport = true
        }
        _this.loadSalaryExternalEmployeeSalaryBillData()

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditViewForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 加载数据
    loadSalaryExternalEmployeeSalaryBillData () {
      let _this = this
      viewSalaryExternalEmployeeSalaryBillApi({ id: _this.dataId }).then(res => {
        const { data } = res
        for (let key in _this.dialogAddEditViewForm) {
          _this.dialogAddEditViewForm[key] = data[key]
        }
        findSummaryInfoByIdApi({recordId: _this.dataId}).then(res1 => {
            _this.infoListData = res1.data
        })
      })
    },
    modalClose () {
      let _this = this;
      _this.$emit('update:dialogVisible', false)
      _this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 导出数据API
    exportSummaryInfoById () {
      let _this = this;
      let excelTitleArray = '省区名称,城市名称,人员名称,应发合计,实发合计'.split(',')
      let excelFieldArray = 'provinceName,cityName,employeeName,payableTotal,paymentTotal'.split(',')
      exportSummaryInfoByIdApi({recordId: _this.dataId, excelTitleArray: excelTitleArray, excelFieldArray: excelFieldArray}).then(response => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    },
    exportInfoById () {
      let _this = this;
      let excelTitleArray = '人员名称,方案编号,活动编号,活动日期,应发金额,实发金额'.split(',')
      let excelFieldArray = 'employeeName,schemeNo,sellId,activityDate,payableAmount,paymentAmount'.split(',')
      exportInfoByIdApi({recordId: _this.dataId, excelTitleArray: excelTitleArray, excelFieldArray: excelFieldArray}).then(response => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
</style>
